// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AmuletRules } from '@daml.js/splice-amulet/lib/Splice/AmuletRules';
import { useScanProxyApiClient } from '../../../contexts/ScanProxyApiContext';
import TemplateContract from '../../../utils/TemplateContract';

const useCoinRules: () => UseQueryResult<TemplateContract<AmuletRules>, string> = () => {
  const scanProxyApi = useScanProxyApiClient();

  return useQuery({
    queryKey: ['getAmuletRules'],
    queryFn: async () => {
      const amuletRulesResponse = await scanProxyApi.getAmuletRules();
      const amuletRules = TemplateContract.fromScanProxyAPI(
        AmuletRules,
        amuletRulesResponse.amulet_rules.contract,
      );
      return amuletRules;
    },
    refetchInterval: false,
  });
};

export default useCoinRules;
